jQuery( document ).ready( function ( $ ) {
	if( $(".block-mp-horizontal-icon-slider" ).length ) {
		let $sliderList = $('.block-mp-horizontal-icon-slider .horizontal-slider-list');
		let $sliderNav = $('.block-mp-horizontal-icon-slider .slider-nav-dots');

		const sliderOptions = {
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			speed: 4000,
			autoplaySpeed: 0,
			cssEase: "linear",
			mobileFirst: true,
			arrows: false,
			dots: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: false,
			waitForAnimate: false,
			responsive: [
				{
					breakpoint: 1100,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 7,
						slidesToScroll: 1,
					}
				},
			]
		};

		function initSlider() {
			$sliderList.slick(sliderOptions);
		}

		initSlider();

		document.addEventListener("visibilitychange", function () {
			if (document.hidden) {
				$sliderList.slick('slickPause');
			} else {
				$sliderList.slick('slickPlay');
			}
		});

		let resizeTimer;
		$(window).on('resize orientationchange', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				if ($sliderList.hasClass('slick-initialized')) {
					$sliderList.slick('unslick');
				}

				initSlider();
			}, 300);
		});
	}
})
